export enum ContentPages {
  BVG = 'bvg',
  DOCS = 'docs',
  ADVICE = 'advice',
  ANALYTICS = 'analytics',
}
